import { ProfileCardComponent } from '@/components/public-profile-card/profileCard'
import { createProfileDetailsForTS, getFullNameCSS } from '@/lib/profileFunction'
import Link from 'next/link'
import { TypesenseData } from '@/lib/typesenseFunction'
import RenderRichTexComponent from '../rich-text-render/richTextRender'
interface IProps {
  profileData: TypesenseData
}

export const LobyProfileCard = ({ profileData }: IProps) => {
  const arrayOfData = createProfileDetailsForTS(profileData)
  const fullNameLength = profileData.fullName?.length ? profileData.fullName?.length : 0
  const isProfessor = profileData.status?.includes('Professor')
  const href = isProfessor ? `/professor/${profileData.slug}` : `/individual/${profileData.slug}`

  const typesenseSource = profileData.source //MongoDB or CMS

  let nodeDescription = <></>
  if (profileData && typeof profileData === 'object' && 'description' in profileData) {
    if (typesenseSource === 'MongoDB') {
      nodeDescription = (
        <div className="  sm:flex hidden">
          <span
            className={`profileDescription max-h-[100px] text-sm !line-clamp-5 hidden sm:block`}
          >
            {profileData.description}
          </span>
        </div>
      )
    } else if (typesenseSource === 'CMS') {
      nodeDescription = (
        <div className=" profileDescription max-h-[100px] line-clamp-5 hidden sm:block">
          <RenderRichTexComponent
            textOnly={true}
            richTextField={profileData.description ? JSON.parse(profileData.description) : ''}
          />
        </div>
      )
    }
  }

  return (
    <Link
      className="flex sm:flex-col flex-row justify-center items-center bg-gray-50 rounded-md border border-gray-200 shadow-cards h-[120px]  sm:w-[220px] sm:h-[445px] sm:ml-2.5 mb-3 sm:mb-2.5 sm:pt-[15px] sm:px-[15px] sm:pb-[24px] hover:border-gray-600 hover:shadow-cardHover hover:bg-gray-100"
      href={href}
    >
      <ProfileCardComponent
        profileData={profileData}
        profilePicture={{
          pictureDivCSS: 'w-[100px] sm:w-[190px] flex h-[100px] sm:h-[188px] rounded-md mx-[12px]',
          pictureCSS: 'rounded-md',
        }}
        profileFullName={{
          fullNameDivCSS: 'sm:pt-2 ',
          fullNameCSS: `${getFullNameCSS(
            fullNameLength,
          )} block font-bold relative bottom-[3px] sm:bottom-[0px] `,
        }}
        moreDetails={{
          ifShow: true,
          value: arrayOfData,
          showMore: false,
          detailsCSS: 'sm:h-[84px] h-[70px] relative bottom-[8px] sm:bottom-[0px] text-sm mb-2',
        }}
        profileDescription={{
          ifShow: true,
          descriptionNode: nodeDescription,
        }}
        informationCSS="w-[190px] sm:min-h-[225px]"
      />
    </Link>
  )
}

export default LobyProfileCard
